import OpenSeadragon from 'openseadragon'
import indexStrip from './indexStrip'
import { AssetsService } from 'shared-utils'

const homeIcon = AssetsService.getSvgIcon('home.svg')
const onPremiseshomeIcon = AssetsService.getSvgIcon('on-premises-home.svg')
const rulerIcon = AssetsService.getSvgIcon('ruler.svg')
const fullPageIcon = AssetsService.getSvgIcon('full-screen.svg')
const modeContainerIcon = AssetsService.getSvgIcon('mode-container.svg')
const modeContainerSelectedIcon = AssetsService.getSvgIcon('mode-container-grey.svg')
const modePointerSplitIcon = AssetsService.getSvgIcon('mode-pointersplit.svg')
const modePointerSplitSelectedIcon = AssetsService.getSvgIcon('mode-pointersplit-grey.svg')
const modeLayersIcon = AssetsService.getSvgIcon('mode-layers.svg')
const modeLayersSelectedIcon = AssetsService.getSvgIcon('mode-layers-grey.svg')
const rotateIcon = AssetsService.getSvgIcon('rotate-right.svg')
const indexIcon = AssetsService.getSvgIcon('index.svg')
const prevPageIcon = AssetsService.getSvgIcon('prevStep.svg')
const nextPageIcon = AssetsService.getSvgIcon('nextStep.svg')

function hideFullPageButtonOnIOSSinceItDoesntWork() {
  const devicesToCheck = ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod']

  const shouldHideFullPageButton =
    navigator.platform &&
    devicesToCheck.reduce((isIos, currentDevice) => isIos || navigator.platform === currentDevice, false)

  if (shouldHideFullPageButton) {
    document.getElementById('full-page').style.transform = 'scale(0)'
  }
}

function getToolbarSvgElement(importedImg, idElem, initColor) {
  fetch(importedImg)
    .then(response => response.text())
    .then(svgContent => {
      //console.log(svgContent)
      //const div = document.querySelector('#' + idElem)
      const container = document.querySelector('#' + idElem + ' .toolbar-component')
      // container.addEventListener('click', (elem) => {
      //   console.log(elem)
      //   document.querySelectorAll('.pressed').forEach((element) => {
      //     element.classList.remove('pressed')
      //   })
      //   div.classList.add('pressed')
      // })
      container.innerHTML = svgContent
      const svgElement = container.querySelector('svg')
      svgElement.querySelectorAll('path').forEach(path => {
        path.setAttribute('fill', !initColor ? '#000000' : initColor)
      })
    })
    .catch(error => console.error('Error fetching the SVG:', error))
}

function getLargeIconClass(largeIcons) {
  return largeIcons ? 'button-on-premises' : ''
}

function is360ViewerDevice() {
  return isMetaQuestBrowser() || isVisionProBrowser() ? 'spatial-component' : ''
}

function getDeviceTollbarTitle(elem) {
  return isMetaQuestBrowser() || isVisionProBrowser() ? elem : ''
}

function isMetaQuestBrowser() {
  const userAgent = navigator.userAgent
  return userAgent.includes('OculusBrowser') && userAgent.includes('Quest')
}

function isVisionProBrowser() {
  if (navigator && navigator.userAgent.includes('Macintosh') && navigator.maxTouchPoints >= 5) {
    return true
  }
  return false
}

// disable button when creating toolbar
document.addEventListener(
  'load',
  () => {
    let disabledBtn = document.querySelector('.pageButton.disabled')
    if (disabledBtn) disabledBtn.querySelector('button').disabled = true
  },
  true
)

export default {
  createToolbarDom: function (ppi, isMultiViewMode, canRotate, largeIcons, numberOfImages, title, thumbLinks) {
    const modesButtonGroupId = 'modes-button-group'
    const toolbarContainerId = 'toolbarContainer'

    console.log(isMultiViewMode)

    const toolbarDomBottom = `
      <div class="toolbarContainer ${
        largeIcons ? 'toolbarContainer-on-premises' : ''
      } ${is360ViewerDevice()}" id="${toolbarContainerId}">
        <div class="${is360ViewerDevice()}" id="${modesButtonGroupId}">
          <div class="btn-toolbar pressed ${is360ViewerDevice()} ${getLargeIconClass(largeIcons)}" id="mode-container">
            <button class="toolbar-component" type="button"/>
          </div>
          <div class="btn-toolbar ${is360ViewerDevice()} ${getLargeIconClass(largeIcons)}" id="mode-split">
            <button class="toolbar-component" type="button"/>
          </div>
          <div class="btn-toolbar ${is360ViewerDevice()} ${getLargeIconClass(largeIcons)}" id="mode-layers">
            <button class="toolbar-component" type="button"/>
          </div>
        </div>
        <div class="${is360ViewerDevice()}" id="viewer-controls">
          <div class="btn-toolbar ${is360ViewerDevice()} ${getLargeIconClass(
      largeIcons
    )} iconSvg hidden" id="homePage" onclick="parent.dispatchEvent(new Event('go-home'))">
            <button class="toolbar-component" type="button"/>
          </div>
          <div class="btn-toolbar ${is360ViewerDevice()} pageButton hidden ${getLargeIconClass(
      largeIcons
    )}  iconSvg" id="toggleIndex">
            <button class="toolbar-component" type="button"/>
          </div>
          <div class="btn-toolbar ${is360ViewerDevice()} pageButton pageButtonPrev disabled hidden ${getLargeIconClass(
      largeIcons
    )} iconSvg" id="prevPage">
            <button class="toolbar-component" type="button"/>
          </div>
          <div class="btn-toolbar ${is360ViewerDevice()} pageButton pageButtonNext hidden ${getLargeIconClass(
      largeIcons
    )} iconSvg" id="nextPage">
            <button class="toolbar-component" type="button"/>
          </div>
          <div class="btn-toolbar ${is360ViewerDevice()}" id="ruler">
            <button class="toolbar-component" type="button"/>
          </div>
          <div class="btn-toolbar ${is360ViewerDevice()}" id="home">
            <button class="toolbar-component" type="button"/>
          </div>
          <div class="btn-toolbar ${is360ViewerDevice()} ${getLargeIconClass(largeIcons)}" id="full-page">
            <button class="toolbar-component" id="" type="button"/>
          </div>
          <div class="btn-toolbar ${is360ViewerDevice()} ${getLargeIconClass(largeIcons)} hidden" id="rotate">
            <button class="toolbar-component" type="button"/>
          </div>
        </div>
      </div>
    ${indexStrip.createDOM(title, numberOfImages, largeIcons, thumbLinks)}
`
      .replace(/\n/g, '')
      .replace(/>\s+/g, '>')

    const toolbarDom = toolbarDomBottom
    const widgetContainer = document.getElementById('widgetContainer')
    widgetContainer.insertAdjacentHTML('afterend', toolbarDom)

    this.showToolbar(toolbarContainerId, canRotate, largeIcons, numberOfImages)
    this.showRulerButton(ppi, largeIcons)
    this.removeTooltip()
    this.configIconSvg()
    this.showModeButtons(isMultiViewMode)
    hideFullPageButtonOnIOSSinceItDoesntWork()
  },
  createPasiToolbarDom: function (canRotate) {
    const toolbarContainerId = 'toolbarContainer'

    const toolbarDom = `
    <div id="${toolbarContainerId}" class="toolbarContainer toolbarContainer-on-premises">
      <div id="viewer-controls-pasi">
        <div id="homePage" class="pasi button button-on-premises iconSvg" onclick="parent.dispatchEvent(new Event('go-home'))">
          <img src ="${onPremiseshomeIcon}">
        </div>
        <div id="home" class="button button-on-premises home-button-pasi iconSvg">
          <img src ="${homeIcon}">
        </div>
        <div id="vis-viewer" class="button button-on-premises switchViewerButton selected">
            VIS
        </div>
        <div id="uv-viewer" class="button button-on-premises switchViewerButton">
            UV
        </div>
        <div id="rest-viewer" class="button button-on-premises switchViewerButton selected">
            REST
        </div>
      </div>
    </div>
`
      .replace(/\n/g, '')
      .replace(/>\s+/g, '>')
    const widgetContainer = document.getElementById('widgetContainer')
    widgetContainer.insertAdjacentHTML('afterend', toolbarDom)

    this.showToolbar(toolbarContainerId, canRotate, true)
    this.removeTooltip()
  },
  configIconSvg: function () {
    getToolbarSvgElement(modeContainerSelectedIcon, 'mode-container')
    getToolbarSvgElement(modePointerSplitIcon, 'mode-split')
    getToolbarSvgElement(modeLayersIcon, 'mode-layers')
    getToolbarSvgElement(onPremiseshomeIcon, 'homePage')
    getToolbarSvgElement(indexIcon, 'toggleIndex')
    getToolbarSvgElement(prevPageIcon, 'prevPage')
    getToolbarSvgElement(nextPageIcon, 'nextPage')
    getToolbarSvgElement(rulerIcon, 'ruler')
    getToolbarSvgElement(homeIcon, 'home')
    getToolbarSvgElement(rotateIcon, 'rotate')
    getToolbarSvgElement(fullPageIcon, 'full-page')
  },
  showToolbar: function (toolbarContainerId, canRotate, largeIcons, numberOfImages) {
    document.getElementById(toolbarContainerId).style.display = 'flex'
    if (canRotate) {
      document.getElementById('rotate').classList.remove('hidden')
    }
    if (largeIcons) {
      document.getElementById('homePage').classList.remove('hidden')
    }
    if (numberOfImages > 1) {
      document.querySelectorAll('.pageButton').forEach(pageButton => {
        pageButton.classList.remove('hidden')
      })
      // document.getElementById('toggleIndex').classList.remove('hidden')
      document.getElementById('itemProgressBar').classList.remove('hidden')
    }
  },
  showRulerButton: function (ppi, largeIcons) {
    if (!ppi || largeIcons) {
      let ruler = document.getElementById('ruler')
      if (ruler) ruler.style.display = 'none'
    }
  },
  removeTooltip: function () {
    OpenSeadragon.setString('Tooltips.FullPage', '')
    OpenSeadragon.setString('Tooltips.Home', '')
    OpenSeadragon.setString('Tooltips.ZoomIn', '')
    OpenSeadragon.setString('Tooltips.ZoomOut', '')
    OpenSeadragon.setString('Tooltips.NextPage', '')
    OpenSeadragon.setString('Tooltips.PreviousPage', '')
  },
  showModeButtons(isMultiViewMode) {
    const mode = isMultiViewMode ? 'flex' : 'none'
    const modesButtonGroupId = 'modes-button-group'
    const modesButtonGroupElement = document.querySelector(`#${modesButtonGroupId}`)
    const modeContainerButton = document.getElementById('mode-container')
    const modeSplitIconButton = document.getElementById('mode-split')
    const modeLayersButton = document.getElementById('mode-layers')

    modesButtonGroupElement.style['display'] = mode

    const modeButtons = [modeContainerButton, modeSplitIconButton, modeLayersButton]
    modeButtons.forEach(button => {
      button.addEventListener('updateImagesVisibility', e => {
        const state = e.detail.state
        const numberOfVisibleImages = state.filter(s => s.visible).length
        if (numberOfVisibleImages > 1) {
          button.classList.remove('disabled')
        } else {
          button.classList.add('disabled')
        }
      })
    })

    modeContainerButton.addEventListener('click', () => {
      document.querySelectorAll('.pressed').forEach(element => {
        element.classList.remove('pressed')
      })
      modeContainerButton.classList.add('pressed')
      document.dispatchEvent(new Event('change-to-mode-container'))
    })

    modeSplitIconButton.addEventListener('click', () => {
      document.querySelectorAll('.pressed').forEach(element => {
        element.classList.remove('pressed')
      })
      modeSplitIconButton.classList.add('pressed')
      document.dispatchEvent(new Event('change-to-mode-split'))
    })

    modeLayersButton.addEventListener('click', () => {
      document.querySelectorAll('.pressed').forEach(element => {
        element.classList.remove('pressed')
      })
      modeLayersButton.classList.add('pressed')
      document.dispatchEvent(new Event('change-to-mode-layers'))
    })

    if (!isMultiViewMode) document.getElementById('viewer-controls').classList.add('center')
  }
}
